import React from 'react';
import makeIconName from '../../utils/makeIconName';
import makeBodyText from '../../utils/makeText';
import styles from './index.module.scss';
const Breadcrumbs = ({ onLocation, navigateTo, title }) => {
    const _handleClick = () => {
        onLocation(navigateTo);
    };
    return (React.createElement("div", { className: styles.breadcrumbsWrap },
        React.createElement("button", { onClick: () => _handleClick(), className: `${makeIconName('arrow_left', 'x24')} ${styles.backBtn}`, type: 'button', "aria-label": 'Go back' }),
        React.createElement("span", { className: `${makeBodyText('L')} ${styles.title}` }, title)));
};
export default Breadcrumbs;
